// extracted by mini-css-extract-plugin
export default {"title":"taskTitle_title__-1cm7","titleDisabled":"taskTitle_titleDisabled__z9jZc","titleAbled":"taskTitle_titleAbled__zxe5I"};